import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-155" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-2xl" data-id="element-156" data-mp="3fze45yusr5w7">
        <h2 className="text-center text-lg font-extrabold uppercase leading-tight text-navy sm:text-2xl" data-id="element-157" data-mp="3fy2z7vpm7s3i">
          What histology &amp; pathology students are saying
        </h2>
        <div className="mt-2 space-y-2" data-id="element-158" data-mp="3700qsv3jxx67">
          {testimonials.map(t => <figure key={t.name} className="rounded-md border border-navy/10 border-l-4 border-l-electric bg-white px-2.5 py-2 shadow-sm" data-id="element-159" data-mp="31zd0ycr27mdk">
              <div className="flex gap-0.5 text-amber-400" role="img" aria-label="5 out of 5 stars" data-id="element-160" data-mp="2x1bi9sxjpp2m">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3 w-3 fill-current" aria-hidden="true" data-id="element-161" data-mp="v9ydd3vkvh6k" data-mpi={i} />)}
              </div>
              <blockquote className="mt-1 text-sm leading-snug sm:text-base" data-id="element-162" data-mp="qbn5uzsr9iri">“{t.quote}”</blockquote>
              <figcaption className="mt-1.5 text-xs leading-tight sm:text-sm" data-id="element-163" data-mp="h555fnoyd5q8">
                <span className="font-extrabold text-navy" data-id="element-164" data-mp="m62pk5tiw9ud">{t.name}</span>
                <span className="text-ink/70" data-id="element-165" data-mp="780l7teo3kc2">
                  {' '}
                  — {t.role} · {t.location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}